import styled from 'styled-components';

export const StyledProgressWrapper = styled.div`
  background-color: ${(props) => props?.theme?.colors?.PRIMARY?.LIGHTGRAY};
  width: 100%;
  position: relative;
  height: 4px;
  border-radius: 2px;
`;

export const StyledProgressBar = styled.div`
  background-color: ${(props) => props?.theme?.colors?.PRIMARY?.DARK};
  width: ${(props) => props.value}%;
  position: absolute;
  height: 4px;
  border-radius: 2px;
  transition: 400ms linear;
`;
